<template>
	<article class="content page">
		<nav class="breadcrumb">
			<router-link to="/"><i class="fas fa-arrow-left"></i> My Account</router-link>
		</nav>
		<h1>404</h1><p>"{{ path }}" is nowhere to be found.</p>
	</article>
</template>

<script>
export default {
	name: 'PageNotFound',
	computed: {
		path() {
			    return this.$route.path;
		    }
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// ./src/views/PageNotFound.vue